import { configureStore } from '@reduxjs/toolkit';
import requestsReducer from './slices/requestsSlice';
import usersReducer from './slices/usersSlice';
import applicationsReducer from './slices/applicationsSlice';
import dashboardReducer from './slices/dashboardSlice';
import companiesReducer from './slices/companiesSlice';
import reminderFrequencyReducer from './slices/reminderFrequencySlice';
import authReducer from './slices/authSlice';
import subtypesReducer from './slices/subtypesSlice';
import rolesReducer from './slices/rolesSlice';
import  archiveReducer from './slices/archiveSlice';
import jobsReducer from './slices/jobsSlice';
import divisionReducer from './slices/divisionSlice';
import branchReducer from './slices/branchSlice';
import categoryReducer from './slices/categorySlice';
import currencyReducer from './slices/currencySlice';
import exchangeRateReducer from './slices/exchangeRateslice';


const nex_store = configureStore({
  reducer: {
    requests: requestsReducer,
    users: usersReducer,
    applications: applicationsReducer,
    dashboard: dashboardReducer,
    company:companiesReducer,
    auth:authReducer,
    subtypes:subtypesReducer,
    reminderFrequency:reminderFrequencyReducer,
    roles:rolesReducer,
    archive:archiveReducer,
    jobs:jobsReducer,
    division:divisionReducer,
    branch:branchReducer,
    category:categoryReducer,
    currency: currencyReducer,
    exchangeRate:exchangeRateReducer
  },
});

export type RootState = ReturnType<typeof nex_store.getState>;
export type AppDispatch = typeof nex_store.dispatch;

export default nex_store;